import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var ArrowUpIcon = function (_a) {
    var size = _a.size, className = _a.className, color = _a.color;
    return (_jsxs("svg", { className: className, width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "".concat(color ? color : "white"), strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: [_jsx("line", { x1: "12", y1: "19", x2: "12", y2: "5" }), _jsx("polyline", { points: "5 12 12 5 19 12" })] }));
};
